import { CommonModule } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  IonButton,
  IonCard,
  IonCol,
  IonIcon,
  IonRow,
} from '@ionic/angular/standalone';
import { take } from 'rxjs';
import {
  HomeMessage,
  MESSAGE_TYPE,
} from 'src/app/core/models/home/message.model';
import { HomeMessageService } from 'src/app/core/services/home/home-message.service';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { BUTTON_CLICK } from '../../shared/modal/warning-modal/warning-modal.constants';
import { IMAGE_SRC } from '../../shared/shared-constants';
import { EditMessageModalComponent } from '../edit-message-modal/edit-message-modal.component';
import { CONSTS } from './message-card.constants';

@Component({
  selector: 'app-message-card',
  imports: [IonCard, IonRow, IonCol, IonIcon, IonButton, CommonModule],
  templateUrl: './message-card.component.html',
  styleUrl: './message-card.component.scss',
})
export class MessageCardComponent {
  index = input.required<number>();
  messageInput = input.required<HomeMessage>();
  canSeeButtons = input.required<boolean>();
  reload = output();

  private dialog = inject(MatDialog);
  private homeService = inject(HomeMessageService);
  private commonUtils = inject(CommonUtils);

  readonly MESSAGE_TYPE = MESSAGE_TYPE;
  readonly IMAGE = IMAGE_SRC;
  readonly CONSTS = CONSTS;

  clickEdit(message: HomeMessage) {
    this.dialog
      .open(EditMessageModalComponent, {
        disableClose: true,
        width: '32vw',
        data: {
          data: message,
          edit: true,
        },
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((value) => {
        if (value) {
          this.reload.emit();
        }
      });
  }

  clickDelete(message: HomeMessage) {
    this.commonUtils
      .openWarningModal({
        header: CONSTS.DELETE_MODAL.HEADER,
        body: CONSTS.DELETE_MODAL.BODY.replace('%s', message.header),
        confirmButtonText: CONSTS.DELETE_MODAL.CONFIRM_BUTTON,
        rejectButtonText: CONSTS.DELETE_MODAL.REJECT_BUTTON,
      })
      .afterClosed()
      .subscribe((resp) => {
        if (resp.button === BUTTON_CLICK.ACCEPT) {
          this.homeService
            .deleteMessage(message.id as number)
            .subscribe((value) => {
              if (value) {
                this.reload.emit();
              }
            });
        }
      });
  }
}
